module.exports = __webpack_public_path__ + "img/ws-1.de4c2569.jpg";